import { BaseElement } from "../Components/Elements/Graphics/BaseElement";
import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { StageController } from "../Components/StageController";
import { ImageElementAttributes } from "../Components/Elements/Graphics/ImageElement";
import { CustomUtils } from "../Utils/CustomUtils";

@engineComponent(ComponentTypes.DisplayObject)
class TilingImageElement extends BaseElement {
    private image: PIXI.extras.TilingSprite;

    private _tint: number = 0xffffff;

    constructor() {
        super();
    }

    get tint(): number {
        return this._tint;
    }

    set tint(tintIn: number) {
        this._tint = tintIn;
        if (this.image) {
            this.image.tint = this._tint;
        }
    }

    public updateByNode(node: Element): void {
        super.updateByNode(node);

        if (node.hasAttribute(TilingImageElementAttributes.IMAGE)) {
            if (!this.image) {
                let texture = StageController.getTextureByResourceId(node.getAttribute(ImageElementAttributes.IMAGE));
                this.image = new PIXI.extras.TilingSprite(texture);
                this.addChild(this.image);
            } else {
                this.image.texture = StageController.getTextureByResourceId(
                    node.getAttribute(ImageElementAttributes.IMAGE),
                );
            }
        }

        if (node.hasAttribute(TilingImageElementAttributes.TINT)) {
            this.tint = parseInt(node.getAttribute(TilingImageElementAttributes.TINT));
        }

        if (!this.image) {
            return;
        }

        if (node.hasAttribute(TilingImageElementAttributes.BLEND_MODE)) {
            this.image.blendMode = CustomUtils.getBlendMode(
                parseInt(node.getAttribute(TilingImageElementAttributes.BLEND_MODE)),
            );
        }

        if (node.hasAttribute(TilingImageElementAttributes.TILE_POSITION_X)) {
            this.image.position.x = parseInt(node.getAttribute(TilingImageElementAttributes.TILE_POSITION_X));
        }
        if (node.hasAttribute(TilingImageElementAttributes.TILE_POSITION_Y)) {
            this.image.position.y = parseInt(node.getAttribute(TilingImageElementAttributes.TILE_POSITION_Y));
        }

        if (node.hasAttribute(TilingImageElementAttributes.TILE_SCALE_X)) {
            this.image.scale.x = parseInt(node.getAttribute(TilingImageElementAttributes.TILE_SCALE_X));
        }
        if (node.hasAttribute(TilingImageElementAttributes.TILE_SCALE_Y)) {
            this.image.scale.y = parseInt(node.getAttribute(TilingImageElementAttributes.TILE_SCALE_Y));
        }

        if (node.hasAttribute(TilingImageElementAttributes.HEIGHT)) {
            this.image.height = parseInt(node.getAttribute(TilingImageElementAttributes.HEIGHT));
        }
        if (node.hasAttribute(TilingImageElementAttributes.WIDTH)) {
            this.image.width = parseInt(node.getAttribute(TilingImageElementAttributes.WIDTH));
        }
    }
}

export const TilingImageElementAttributes = {
    BLEND_MODE: "BlendMode",
    HEIGHT: "Height",
    IMAGE: "Image",
    TILE_POSITION_X: "TilePositionX",
    TILE_POSITION_Y: "TilePositionY",
    TILE_SCALE_X: "TileScaleX",
    TILE_SCALE_Y: "TileScaleY",
    TINT: "Tint",
    WIDTH: "Width",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/TilingImageElement.ts
 **/